import { Datepicker } from 'components/form/Datepicker';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useDebitNoteGeneration(props) {
    const {
        selectedAccount,
        totalRequests,
        generateDebitNote_requesting
    } = props;

    // States
    const [isModalVisible, setIsModalVisible] = useState();
    const [isFormSubmissionAttempted, setIsFormSubmissionAttempted] = useState();
    const [companyId, setCompanyId] = useState();
    const [accountCode, setAccountCode] = useState();
    const [productCode, setProductCode] = useState();
    const [startDateTime, setStartDateTime] = useState();

    function generateDebitNote() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);
        setIsFormSubmissionAttempted(true);

        if (func_validation.isArrayNotEmpty(selectedAccount)) {

            selectedAccount.map((accountDetails, idx) => {
                let comId = func_validation.getObjectPropertyValue(accountDetails, "CompanyId");
                let accountCode = func_validation.getObjectPropertyValue(accountDetails, "AccountCode");
                let productCode = func_validation.getObjectPropertyValue(accountDetails, "ProductCode");
                let startDateTime = func_validation.getObjectPropertyValue(accountDetails, "StartDateTime");

                if (func_validation.isNumberOrStringValid(comId) &&
                    func_validation.isStringTrimNotEmpty(accountCode) &&
                    func_validation.isStringTrimNotEmpty(productCode) &&
                    func_validation.isStringTrimNotEmpty(startDateTime) &&
                    func_validation.isFunction(props.generateDebitNote)) {

                    let obj = {
                        comId,
                        accountCode,
                        productCode,
                        dateBillDate: startDateTime,
                    };

                    props.generateDebitNote(obj);
                }
            });
        }
        else if (func_validation.isNumberOrStringValid(companyId) ||
            func_validation.isStringTrimNotEmpty(accountCode) ||
            func_validation.isStringTrimNotEmpty(productCode) ||
            func_validation.isStringTrimNotEmpty(startDateTime)) {

            if (func_validation.isFunction(props.generateDebitNote)) {
                let obj = {
                    comId: companyId,
                    accountCode,
                    productCode,
                    dateBillDate: startDateTime,
                };
                props.generateDebitNote(obj);
            }
        }
        else {
            Toaster({
                type: "info",
                msg: "Please fill in at least 1 input.",
            });
        }
    }

    useEffect(() => {
        setCompanyId("");
        setAccountCode("");
        setProductCode("");
        setStartDateTime("");
    }, [isModalVisible]);

    let generateDebitNoteModal = (
        <ConfirmationModal
            description={"Generating advance pay invoice(s)"}
            input={(!func_validation.isArrayNotEmpty(selectedAccount)) ? (
                <div className={"advance-pay-setup__generate-debit-note"}>
                    {/* Company ID */}
                    <FormInput_text
                        inputLabel={"Company ID"}

                        className={"generate-debit-note__company-id"}
                        inputValue_default={companyId}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setCompanyId(value); }}

                        inputMaxLength={64}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        isInputOptional
                    />

                    {/* Account Code */}
                    <FormInput_text
                        inputLabel={"Account Code"}

                        className={"generate-debit-note__account-code"}
                        inputValue_default={accountCode}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setAccountCode(value); }}

                        inputMaxLength={3}

                        isInputValueTrim_onChange
                        isMarginBtmOptional
                        isInputOptional
                    />

                    {/* Product Code */}
                    <FormInput_text
                        inputLabel={"Product Code"}

                        className={"generate-debit-note__product-code"}
                        inputValue_default={productCode}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setProductCode(value); }}

                        inputMaxLength={3}

                        isInputValueTrim_onChange
                        isMarginBtmOptional
                        isInputOptional
                    />

                    {/* Start Date Time */}
                    <Datepicker
                        className={"generate-debit-note__start-date-time"}
                        inputClassName={"start-date-time__input"}

                        label={"Start Datetime"}
                        dateFromParent={startDateTime}
                        defaultDate={startDateTime}
                        handleOnChange={setStartDateTime}

                        isConversionRequired_ISO8601
                    />
                </div>
            ) : ""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={generateDebitNote}
            isActionLoading={generateDebitNote_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        generateDebitNoteModal,
        setIsModalVisible
    };
}